export const WhitelabelConstants = {
    GETWHITELABEL_REQUEST : 'GETWHITELABEL_REQUEST',
    GETWHITELABEL_SUCCESS : 'GETWHITELABEL_SUCCESS',
    GETWHITELABEL_FAILURE : 'GETWHITELABEL_FAILURE'
}


// WEBPACK FOOTER //
// ./src/store/constants/whitelabel.constants.js